import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const getVariantInventoryByLocation = unaryRpc({
  name: "getVariantInventoryByLocation" as const,
  input: z.object({ variantId: z.string() }),
  output: z
    .object({
      variantId: z.string(),
      locations: z.array(
        z.object({
          locationId: z.string(),
          locationName: z.string(),
          available: z.number(),
          onHand: z.number(),
          committed: z.number(),
          incoming: z.number(),
          damaged: z.number().optional(),
          qualityControl: z.number().optional(),
          safetyStock: z.number().optional(),
        }),
      ),
      totalAvailable: z.number(),
      totalOnHand: z.number(),
    })
    .optional(),
});
